import Link from '@/components/Common/Link'
import Text from '@/stories/components/Common/NewText'
import classNames from 'classnames'

type TProps = {
  text: string
  link?: string
}

const StrapiV4Chiclet = ({ text, link }: TProps) => {
  const textJsx = (
    <Text
      tag="p"
      addClassName="text-brand-white whitespace-nowrap rounded border border-brand-white py-1 px-2 hover:text-brand-grey-light hover:border-brand-grey-light duration-200 transition-colors !text-xs"
    >
      {text}
    </Text>
  )

  if (link) {
    return (
      <Link href={link} title={text}>
        {textJsx}
      </Link>
    )
  }

  return textJsx
}

export default StrapiV4Chiclet
